import { useState, useEffect } from 'react';

var useTypingEffect = function useTypingEffect(strings) {
  var _a = useState({
    stringIndex: 0,
    characterIndex: 0
  }),
      _b = _a[0],
      stringIndex = _b.stringIndex,
      characterIndex = _b.characterIndex,
      setState = _a[1];

  var timeoutId;

  var emulateKeyStroke = function emulateKeyStroke() {
    characterIndex++;

    if (characterIndex === strings[stringIndex].length) {
      characterIndex = 0;
      stringIndex++;

      if (stringIndex === strings.length) {
        stringIndex = 0;
      }

      timeoutId = window.setTimeout(emulateKeyStroke, 100);
    } else if (characterIndex === strings[stringIndex].length - 1) {
      timeoutId = window.setTimeout(emulateKeyStroke, 2000);
    } else {
      timeoutId = window.setTimeout(emulateKeyStroke, 100);
    }

    setState({
      characterIndex: characterIndex,
      stringIndex: stringIndex
    });
  };

  useEffect(function () {
    emulateKeyStroke();
    return function () {
      window.clearInterval(timeoutId);
    };
  }, []);
  var nonBreakingSpace = "\xA0";
  return strings[stringIndex].slice(0, characterIndex + 1) || nonBreakingSpace;
};

export default useTypingEffect;
export { useTypingEffect };